import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { CallerService } from '../services/caller.service'
import { RETURN_URL_QUERY_PARAM } from '../utils/return-url.util'

/**
 * The header of a listing's own page (/a/:id, /s/:id, /ppa/:id) - pages people reach from a shared link, outside
 * NavComponent. Logged in, a way back to the list; logged out, Login / Sign up that come back to this page.
 */
@Component({
  selector: 'app-listing-page-header',
  templateUrl: './listing-page-header.component.html',
})
export class ListingPageHeaderComponent {
  /** The list this page belongs to, and what to call it ("All houses"). */
  @Input() backLink = '/home'
  @Input() backLabel = 'Back'

  constructor(
    public callerService: CallerService,
    private router: Router,
  ) {}

  /** After logging in or signing up, back to this page. */
  get returnHere(): Record<string, string> {
    return { [RETURN_URL_QUERY_PARAM]: this.router.url.split(/[?#]/)[0] }
  }
}
